import * as z from "zod";
import { dateSchema } from "./schemasComplex";
import { zRequiredString } from "./schemaUtils";

export const schemaDefinePilote = z.object({
  pilote: zRequiredString("Veuillez dÃ©finir un pilote"),
  gravity: zRequiredString("Veuillez dÃ©finir la gravitÃ©"),
  theme: zRequiredString("Veuillez dÃ©finir un thÃ¨me"),
  dateAsked: dateSchema,
  needsCauseAnalysis: z.boolean(),
  needsActions: z.boolean(),
});
